import { useTranslation } from "react-i18next"
import { ColumnItem } from "../../../../../../../utils/types/generals"
import { ReassignRow } from "../components/reassign/types"
import { Checkbox, Radio } from "@mui/material"
import { ReassignColumns, TrackingColumns } from "../types"

export const useReassignColumn = ({ userToReassignId, selectUser }: ReassignColumns): ColumnItem[] => {
    const { t } = useTranslation()
    return [
        {
            id: 'name',
            label: t('reportFolio.table.name'),
        },
        {
            id: 'curp',
            label: t('reportFolio.table.curp'),
        },
        {
            id: 'role',
            label: t('reportFolio.table.role'),
        },
        {
            id: 'userType',
            label: t('reportFolio.table.userType'),
        },
        {
            id: 'division',
            label: t('reportFolio.table.division'),
        },
        {
            id: 'reassignTo',
            label: t('reportFolio.table.reassignTo'),
            rowTdStyles: {width: '80px', textAlign: 'center'},
            headerCell: {width: '80px'},
            renderCell: (params) => {
                const row: ReassignRow = params.row
                return (<Radio checked={userToReassignId == row.id} onClick={() => { selectUser({ id: row.id }) }} />)
            }
        },
    ]
}
export const useTrackingColumn = ({ selectUser, selectUserAll, userToTracking, allUsersSelecteds }: TrackingColumns): ColumnItem[] => {
    const { t } = useTranslation()
    return [
        {
            id: 'action',
            label: '',
            rowTdStyles: { textAlign: 'center' },
            column: () => {
                return (<Checkbox checked={allUsersSelecteds} onClick={selectUserAll} />)
            },
            renderCell: (params) => {
                const row: ReassignRow = params.row
                return (<Checkbox checked={userToTracking.includes(row.id)} onClick={() => { selectUser({ id: row.id }) }} />)
            }
        },
        {
            id: 'name',
            label: t('reportFolio.table.name'),
        },
        {
            id: 'curp',
            label: t('reportFolio.table.curp'),
        },
        {
            id: 'role',
            label: t('reportFolio.table.role'),
        },
        {
            id: 'userType',
            label: t('reportFolio.table.userType'),
        },
        {
            id: 'division',
            label: t('reportFolio.table.division'),
        },
    ]
}